module.exports = __webpack_public_path__ + "img/site_cover_mobile.69afffa5.png";